import { useEffect, useState } from "react";
import { selectEntryChannelsLoadingPag, selectEntryChannelsPag } from "../../redux/entryChannels/selectors";
import { AdminTable } from "./AdminTable";
import { useDispatch, useSelector } from "react-redux";
import { Column } from "devextreme-react/data-grid";
import { openModal } from "../../redux/modal/modalSlice";
import { useTranslation } from "react-i18next";
import { selectActionResolutionsLoadingPag, selectActionResolutionsPag } from "../../redux/actionResolutions/selectors";
import { QUERY_DELETE_DELETEACTIONRESOLUTION, QUERY_GET_ACTIONRESOLUTIONSPAG, QUERY_POST_CREATEACTIONRESOLUTION } from "../../fetch/constantQueries";
import { createActionResolution, deleteActionResolution, editActionResolution, getActionResolutionsPag } from "../../redux/actionResolutions/thunks";


const initialSortOptions = {
    columna: "actionResolutionId",
    sortOrderAsc: true

}

function ActionResolutionManagement() {
    const { t } = useTranslation();
    const actionResolutions = useSelector(selectActionResolutionsPag);
    const dispatch = useDispatch();
    const loading = useSelector(selectActionResolutionsLoadingPag);
    const [sortOptions, setSortOptions] = useState(initialSortOptions)
    

    useEffect(()=>{
        getListActionResolutions(mapPageInfo(actionResolutions));
    }, [])

    function mapPageInfo(data){
        return {
            pageIndex: data.pageIndex ?? 0,
            pageSize: data.pageSize ?? 10,
            orderByField:  data.columna ?? "actionResolutionId",
            orderByAscending:  data.sortOrderAsc ?? true
        }
    }
      
    const getListActionResolutions = (pageInfo) => {
        let query = `?pageIndex=${pageInfo.pageIndex}&pageNum=${pageInfo.pageSize}`
        if(pageInfo.searchString?.trim().length > 0){
            query = query.concat(`&searchString=${pageInfo.searchString.trim()}`)
        }
        if(pageInfo.orderByField)
            {
                query = query.concat(`&orderByField=${pageInfo.orderByField}&orderByAscending=${pageInfo.orderByAscending}`)
            }
        dispatch(getActionResolutionsPag({query}));
    }

    const columnsActionResolutions = [
        <Column sortIndex={1} key={"actionResolution-1"} dataField="actionResolutionId" caption="Id" allowEditing={false} allowCreating={false}/>, 
        <Column key={"actionResolution-2"} dataType={"string"} dataField="actionResolutionName" caption="Descrição" />, 
    ] 

    function handleSaveNewactionResolutionClick(value, closeCreateModal) {   
        const actionResolutionDescription = value.actionResolutionName.trim();    
        if(actionResolutionDescription){
            const actionResolutionDescriptionExists = actionResolutions.elements.some(actionResolution => actionResolution.actionResolutionName.toLowerCase() === actionResolutionDescription.toLowerCase());
            if(actionResolutionDescriptionExists)
                dispatch(openModal({ type: "warning", message:"La Descrição introducida ya existe."}))
            else{
                const actionResolutionParams ={body:{
                    actionResolutionName: actionResolutionDescription}
                }
                dispatch(createActionResolution(actionResolutionParams)).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListActionResolutions(mapPageInfo({...actionResolutions, ...sortOptions}));
                        closeCreateModal();
                    }                    
                })
            }            
        }else{
           closeCreateModal()
        }       
    }    

    const handleEditClick = (value, closeEditModal) => {
        const actionResolutionDescription = value.actionResolutionName.trim() ; 
        if(actionResolutionDescription){
            const descriptionExists = actionResolutions.elements.some(actionResolution => actionResolution.actionResolutionName.toLowerCase() === actionResolutionDescription.toLowerCase());            
            if(descriptionExists && actionResolutionDescription.toLowerCase() !== actionResolutions.elements.find(actionResolution => actionResolution.actionResolutionId === value.actionResolutionId)?.description.toLowerCase()) //La descripción ya existe y es distinta a la actual
                dispatch(openModal({ type: "warning", message:"La Descrição introducida ya existe."}))
            else{
                const editActionResolutionParams ={
                    param: value.actionResolutionId,
                    actionResolutionId: value.actionResolutionId,
                    body:{        
                        actionResolutionName: actionResolutionDescription
                    } 
                }
                dispatch(editActionResolution(editActionResolutionParams)).then((data) => {
                    if(data.error)
                        dispatch(openModal({ type: "warning", message:data.error.message}))
                    else{
                        getListActionResolutions(mapPageInfo({...actionResolutions, ...sortOptions}));
                        closeEditModal()
                    }    
                })
            }
        }else{
           closeEditModal()
        }             
    }

    const handleDeleteClick = (id, closeDeleteModal) => {
        dispatch(deleteActionResolution({param: id})).then((data) => {
            if(data.error)
                dispatch(openModal({ type: "warning", message:data.error.message}))
            else{
                let updatedPageIndex = actionResolutions.pageIndex;

                if (actionResolutions.elements.length === 1) {
                    updatedPageIndex = Math.max(0, actionResolutions.pageIndex - 1);
                }

                const updatedActionResolutions = {
                    ...actionResolutions,
                    pageIndex: updatedPageIndex,
                };

                getListActionResolutions(mapPageInfo({...updatedActionResolutions, ...sortOptions}));
                closeDeleteModal()           
            }
        })  
    }

    function allowDelete(rowData){
        return rowData.data.custom;
    }

    return(
        <div style={{width: "100%"}}>
            <AdminTable
                sectionTitle={"Resoluções"} 
                masterTitle={"Resolução"} 
                itemIdField={"actionResolutionId"} 
                itemDescriptionField={"actionResolutionName"} 
                loading={loading} 
                getData={getListActionResolutions} 
                dataSource={actionResolutions} 
                columnasTabla={columnsActionResolutions} 
                onCreate={handleSaveNewactionResolutionClick}
                onDelete={handleDeleteClick}
                onEdit={handleEditClick} 
                numElements={[10, 20, 30]}
                allowDelete={allowDelete}
                sortField={sortOptions}
                setsortField={setSortOptions}
            />
        </div>
    )
}
export default ActionResolutionManagement;